import React, { Component } from 'react';
import ConstCommon from '../../common/Const';
import { withSyncDragCode } from '../../common/sync-drag-code';
import {
  getCodeFromQuery,
  getQueryParams,
  removeDragCode,
  syncComponentSelector,
} from '../../helpers/Common';
import Const from './Const';
import { connect } from 'react-redux';
import InforHeader from './InforHeader';
import { changeCode, fetchListDataOwnership } from './reducer';
import './index.scss';
import TabContent from './table-content/TabContent';
import ScrollComponent from './../../common/ScrollComponent';
import ChartOwnership from './ChartOwnership';
import { I18n } from 'react-redux-i18n';
import PreRender from './../../common/PreRender';
import { compose } from 'redux';
import Export from './Export';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';

class Ownership extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listTab: [
        {
          value: 'marjorShareHolders',
          isSelected: true,
          index: Const.listTab.MajorShareHolders.Index,
        },
        {
          value: 'boardOfDirectors',
          isSelected: false,
          index: Const.listTab.BoardOfDirectors.Index,
        },
      ],
      indexSelectTab: props.tab || 1,
    };
    const { glContainer } = props;
    removeDragCode(glContainer);
    const { changeCode, id } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock']);
    if (codeFromQuery) {
      changeCode(codeFromQuery, id);
    }
  }

  componentDidMount() {
    const { fetchListDataOwnership, id } = this.props;
    if (!getQueryParams('code')) {
      fetchListDataOwnership(id);
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchListDataOwnership, id } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      fetchListDataOwnership(id);
    }
  }

  changeTab(value) {
    const { listTab } = this.state;
    const newListTab = listTab.map(item => {
      if (value === item.index)
        return {
          ...item,
          isSelected: true,
        };
      return {
        ...item,
        isSelected: false,
      };
    });
    this.setState({ listTab: newListTab, indexSelectTab: value });
  }

  render() {
    const { listTab, indexSelectTab } = this.state;
    const { id } = this.props;

    return (
      <PreRender {...this.props}>
        <ComponentNameProvider value={ConstCommon.listComponent.Ownership}>
          <Provider value={id}>
            <ScrollComponent>
              <div className="ows-wrapper px-20 min-height-100 d-flex flex-column">
                <div className="wrap-top-content flex-shrink-0">
                  <div className="ows-top-content">
                    <InforHeader id={id} />
                  </div>

                  <div
                    className="wrap-top-content--right"
                    style={{ marginTop: 30 }}
                  >
                    <Export id={id} indexSelectTab={indexSelectTab} />
                  </div>
                </div>
                <div className="ows-body-content d-flex flex-fill mb-10">
                  <div className="left-content mr-10">
                    <ChartOwnership id={id} />
                  </div>
                  <div className="right-content d-flex flex-fill flex-column">
                    <div className="top-tab-content">
                      {listTab.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={`${
                              item.index === indexSelectTab
                                ? 'ows-tab-content-active'
                                : ''
                            } ows-tab-content hover mr-1"`}
                            onClick={() => this.changeTab(item.index)}
                          >
                            {I18n.t(`ownerShip.tabs.${item.value}`)}
                          </div>
                        );
                      })}
                    </div>
                    <TabContent
                      indexSelectTab={this.state.indexSelectTab}
                      id={id}
                    />
                  </div>
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapDispatchToProps = {
  fetchListDataOwnership,
  changeCode,
};

const mapStateToProps = (state, { id, glContainer }) => {
  return {
    i18n: state.i18n,
    syncType: syncComponentSelector(
      state,
      ConstCommon.listComponent.Ownership,
      id,
    ),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withSyncDragCode,
)(Ownership);
